import api from './api'

/**
 * Serviço de Tenants (Clientes/Empresas)
 */
export default {
  /**
   * Listar tenants
   */
  list(params = {}) {
    return api.get('/api/tenants', { params })
  },

  /**
   * Buscar tenant por ID
   */
  getById(id) {
    return api.get(`/api/platform/dashboard/${id}`)
  },

  /**
   * Obter estatísticas de usuários do tenant
   */
  getStats(id) {
    return api.get(`/api/platform/dashboard/tenants/${id}/stats`)
  },

  /**
   * Obter atividades recentes do tenant
   */
  getActivities(id, limit = 10) {
    return api.get(`/api/platform/tenants/${id}/activities`, {
      params: { limit },
    })
  },

  /**
   * Criar tenant
   */
  create(tenantData) {
    return api.post('/api/tenants', tenantData)
  },

  /**
   * Atualizar tenant
   */
  update(id, tenantData) {
    return api.put(`/api/tenants/${id}`, tenantData)
  },

  /**
   * Obter dados de edição do tenant (tenant + admins)
   * GET /api/tenants/{id}/edit
   */
  getEditData(id) {
    return api.get(`/api/tenants/${id}/edit`)
  },

  /**
   * Salvar edição do tenant (dados + admins)
   * PUT /api/tenants/{id}/edit
   */
  saveEditData(id, payload) {
    return api.put(`/api/tenants/${id}/edit`, payload)
  },

  /**
   * Reenviar e-mail de boas-vindas para admin do tenant
   * POST /api/tenants/{tenantId}/admins/{adminId}/resend-welcome
   * @param {Object} [body] - Opcional. Se { email } for diferente, troca o email no Firebase e no banco
   */
  resendWelcomeEmail(tenantId, adminId, body = {}) {
    return api.post(`/api/tenants/${tenantId}/admins/${adminId}/resend-welcome`, body)
  },

  // === TENANT ADMIN - DASHBOARD ===
  
  /**
   * Obter estatísticas do tenant (TENANT_ADMIN)
   */
  getTenantStats() {
    return api.get('/api/admin-tenant/stats')
  },

  /**
   * Listar gestores do tenant (TENANT_ADMIN)
   */
  getManagers(params = {}) {
    return api.get('/api/admin-tenant/managers', { params })
  },

  /**
   * Obter detalhes de um gestor específico (TENANT_ADMIN)
   */
  getManagerDetails(managerId) {
    return api.get(`/api/tenant/managers/${managerId}`)
  },
}
